<!-- BaseSearchForm.vue (admin) -->
<template tag="관리자 검색 폼 컴포넌트">
  <div class="d-flex align-center search-form">
    <BaseInput
      v-model="model"
      type="search"
      :placeholder="placeholder"
      density="compact"
      variant="plain"
    />
    <BaseButton variant="text" icon="mdi-magnify"></BaseButton>
  </div>
</template>

<script setup lang="ts">
/* ------------------------------------------------------------
                        Vue Instance & Global Properties
    ------------------------------------------------------------ */
import { i18n } from "@/app/plugins/global";
const { $text } = i18n();

/* ------------------------------------------------------------
                        Model
    ------------------------------------------------------------ */
const model = defineModel<string>({ required: true });

/* ------------------------------------------------------------
                        Props
    ------------------------------------------------------------ */
const props = defineProps({
  placeholder: { type: String, default: "" },
});

/* ------------------------------------------------------------
                        Variable Declarations
    ------------------------------------------------------------ */
/** 기본값 적용 */
const placeholder = props.placeholder || $text("message.searchPlaceholder");
</script>
<style lang="scss">
.search-form {
  height: 40px;
  padding: 0 8px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background-color: #fff;
  .v-input,
  .v-field,
  button {
    height: 100%;
    min-height: 100%;
  }
  .v-field__input {
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 8px;
    display: flex;
    align-items: center !important;
    height: 100% !important;
  }
}
</style>
